<template>
    <v-dialog v-if="model && !prerenderMode" v-model="model" persistent width="700">
        <v-card>
            <iframe :src="channelPageUrl + '?hcc=1'" frameborder="0" width="100%" height="300"></iframe>

            <v-card-actions>
                <v-btn @click="model = false">{{'REDIRECTION_MODAL_CLOSE_BUTTON'}}</v-btn>
                <v-spacer/>
                <v-btn :href="channelUrl">{{'REDIRECTION_MODAL_REDIRECT_BUTTON'}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'ChannelSwitcher',
    data() {
        return {
            currentCountry: null,
        };
    },
    created() {
        this.$countryDetectService.detectCountry().then(country => {
            const currentCountry = this.$country.getCountryBy('iso_2', country);

            if (currentCountry) {
                this.currentCountry = currentCountry.id;
            }
        });
    },
    computed: {
        ...mapState('PageContent', [
            'prerenderMode'
        ]),
        currentChannel() {
            return this.$channel.getCurrentChannel();
        },
        channelUrl() {
            let defaultUrl;
            let countryUrl;

            this.currentChannel.channel_redirects.forEach(channelRedirect => {
                if (!channelRedirect.country_id) {
                    defaultUrl = channelRedirect.redirect_url;
                } else if (channelRedirect.country_id === this.currentCountry) {
                    countryUrl = channelRedirect.redirect_url;
                }
            });

            return countryUrl || defaultUrl;
        },
        channelPageUrl() {
            let defaultPageUrl;
            let countryPageUrl;

            this.currentChannel.channel_redirects.forEach(channelRedirect => {
                if (!channelRedirect.country_id) {
                    defaultPageUrl = channelRedirect.page_url;
                } else if (channelRedirect.country_id === this.currentCountry) {
                    countryPageUrl = channelRedirect.page_url;
                }
            });

            return countryPageUrl || defaultPageUrl;
        },
        model: {
            get() {
                return this.$channel.getShowChannelSwitcher();
            },
            set(value) {
                this.$channel.setShowChannelSwitcher(value);
            },
        },
    },
};
</script>